import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * The spec block holds one colour-dependent claim: UPF. Liquid decides per variant
 * whether to render it (see blocks/product-spec.liquid), but the variant picker only
 * morphs itself and the elements that ask -- price, sku and inventory each ship their
 * own listener for exactly this reason. Without this file the shopper would switch to
 * a colour with no UPF test and keep reading "UPF 40+" from the previous variant,
 * which is the precise failure the Liquid gate exists to prevent.
 *
 * Mirrors assets/product-inventory.js deliberately. If that file's pattern changes,
 * change this one with it.
 */
class ProductSpec extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateSpec);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateSpec);
  }

  /**
   * Replaces the spec rows with the ones rendered for the newly selected variant.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateSpec = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newSpec = event.detail.data.html.querySelector('product-spec');

    if (!newSpec) return;

    morph(this, newSpec, { childrenOnly: true });
  };
}

if (!customElements.get('product-spec')) {
  customElements.define('product-spec', ProductSpec);
}
